import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Block = ({ children, className, hidden }) => {
	const ref = useRef(null);
	const blockCx = cx(
		styles.block,
		hidden ? styles.hidden : styles.shown,
		className
	);

	return (
		<div className={blockCx} ref={ref}>
			<div className={styles.inner}> {children}</div>
		</div>
	);
};

Block.propTypes = {
	children: PropTypes.node.isRequired,
	hidden: PropTypes.bool,
	className: PropTypes.string
};

Block.defaultProps = {
	hidden: false
};

export default Block;
